// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAGnwnsZWc8J2ET_nastCnhhsB8t0XeE8Q",
  authDomain: "hmcwalletpro.firebaseapp.com",
  projectId: "hmcwalletpro",
  storageBucket: "hmcwalletpro.appspot.com",
  messagingSenderId: "507096744604",
  appId: "1:507096744604:web:616cdefa527496f6d42359",
  measurementId: "G-ZLWSPYKKXK",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
